import { CreatableListValueSeparator } from './types.js';
export const PLACEHOLDERS = {
    input: 'Search or create item',
    copy: 'Copy',
    copied: 'Copied',
    paste: 'Paste',
    pasted: 'Pasted',
    apply: 'Apply',
    applied: 'Applied',
    clearAll: 'Clear all',
    selected: 'Selected:',
    create: 'Create',
    total: 'Total',
    totalSeparator: 'of',
    sortOrderAsc: 'A-Z',
    sortOrderDesc: 'Z-A',
    errorTitle: 'Error',
    errorAccessDenied: 'Clipboard access denied',
    errorAccessError: 'Clipboard access error',
    errorValueExists: 'Value already exists',
    errorValueEmpty: 'Value cannot be empty',
};
export const LIST_MAX_HEIGHT = 333;
export const ITEM_HEIGHT = 37;
export const SEPARATOR_SPLIT_PATTERN = {
    [CreatableListValueSeparator.COMMA]: ',',
    [CreatableListValueSeparator.SEMICOLON]: ';',
    [CreatableListValueSeparator.TAB]: '\\t',
    [CreatableListValueSeparator.NEWLINE]: '\\r?\\n+',
};
export const SEPARATOR_CONTAINS_REGEX = {
    [CreatableListValueSeparator.COMMA]: /,/,
    [CreatableListValueSeparator.SEMICOLON]: /;/,
    [CreatableListValueSeparator.TAB]: /\t/,
    [CreatableListValueSeparator.NEWLINE]: /\r?\n/,
};
export const DEFAULT_VALUE_SEPARATORS = [CreatableListValueSeparator.COMMA];
export const ALL_VALUE_SEPARATORS = Object.values(CreatableListValueSeparator);
